<template>
  <div class="section">
    <div class="showhover">
      <div
        v-for="it in sub"
        :key="it.key"
        @click.stop="toWhere(it.key)"
        class="hoveritem"
        :style="{ color: showkey == it.key ? '#3170ff' : '' }"
      >
        {{ it.name }}
      </div>
    </div>
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-if="showkey == 1">
          <div class="section content2">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title2">商业综合体能源管控解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title2"
              />
              <p class="title2">COMMERCIAL COMPLEX</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('2')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide" v-if="showkey == 2">
          <div
            class="section bannerClass"
          >
            <div class="main_content pt96 title_wrap">
              <div class="title s_title1">地下停车场智慧照明解决方案</div>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title1"
              />
              <p class="title2">MONOMER BUILDING</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('1')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide" v-if="showkey == 3">
          <div class="section content4">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title3">空调分户计费解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title3"
              />
              <p class="title2">LOW CARBON BUILDINGS</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('4')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide" v-if="showkey == 4">
          <div class="section content3">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title2">文旅项目能源管控解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title2"
              />
              <p class="title2">MULTI-PROJECT MANAGEMENT</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('3')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide" v-if="showkey == 5">
          <div class="section content5">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title4">光储充能源管控解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title4"
              />
              <p class="title2">LIGHT STORAGE CHARGE</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('5')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide" v-if="showkey == 6">
          <div class="section content6">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title4">智慧园区解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title4"
              />
              <p class="title2">Smart park solutions</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('6')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide" v-if="showkey == 7">
          <div class="section content7">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title4">绿色校园解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title4"
              />
              <p class="title2">Green Campus Solutions</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('7')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide" v-if="showkey == 8">
          <div class="section content8">
            <div class="main_content pt96 title_wrap">
              <p class="title s_title4">医院能效解决方案</p>
              <img
                src="../../assets/line.png"
                alt=""
                class="title_line s_title4"
              />
              <p class="title2">Hospital energy efficiency</p>
              <div
                style="margin-top: 59px; font-family: 'Light'"
                class="banner_btn"
                @click="handleSelect('8')"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-scrollbar"></div>
    </div>
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="first"> </el-tab-pane>
        <el-tab-pane label="用户痛点" name="second"></el-tab-pane>
        <el-tab-pane label="方案优势" name="third"></el-tab-pane>
        <el-tab-pane label="客户价值" name="fourth"></el-tab-pane>
        <el-tab-pane label="落地案例" name="five"></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";

export default {
  name: "Service",
  components: {
    swiper,
    swiperSlide,
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    },
  },
  data() {
    return {
      showkey: 1,
      sub: [
        { name: "商业综合体能源管控解决方案", key: "1" },
        { name: "地下停车场智慧照明解决方案", key: "2" },
        { name: "空调分户计费解决方案", key: "3" },
        // { name: "文旅项目能源管控解决方案", key: "4" },
        // { name: "光储充能源管控解决方案", key: "5" },
        { name: "智慧园区解决方案", key: "6" },
        { name: "绿色校园解决方案", key: "7" },
        { name: "医院能效解决方案", key: "8" },

      ],
      activeName: "first"
    };
  },
  mounted() {
    this.showkey = this.$route.query.showkey || 1;
  },
  methods: {
    toWhere(key) {
      this.showkey = key;
    },

    handleSelect(num) {

      let url = [
        "",
        "https://mp.weixin.qq.com/s/fcpSuhEmrf-bun0xg0XE0g",
        "https://mp.weixin.qq.com/s/HQv9UcWkhAEtubKP4gIRuQ",
        "https://mp.weixin.qq.com/s/c2BEpgaypMFExaH8lqCHmA",
        "https://mp.weixin.qq.com/s/kgVAKoY4MYFkDiMCxndygg",
        '',
        "https://mp.weixin.qq.com/s/P2c275QK_Sf2_RVwtSGTpA",
        "https://mp.weixin.qq.com/s/QcPHFWLT5wd2jVkOlDCX0g",
        "https://mp.weixin.qq.com/s/di1pNpBGImCH8PrNe_Dlew",

      ];
      if(num == 5){
        return
      }
      window.open(url[num]);
    },
    handleClick(tab, event) {
      this.$router.push({
        path: `/service${this.showkey}`,
        query: {
          active: this.activeName,
          showkey: this.showkey,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/style/service.scss";

/*去掉el-tab-pane底部灰色线条*/
/deep/ .el-tabs__nav-wrap::after {
  height: 0 !important;
  background: transparent !important;
}
/*去掉el-tab-pane切换时的蓝色下划线*/
/deep/ .el-tabs__active-bar {
  background: transparent !important;
}

/deep/ .el-tabs__item.is-active {
  color: #3170ff;
}

/deep/ .el-tabs__nav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  float: none;
  /* background: linear-gradient(90deg, rgba(52,56,59,0.99)); */
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.1) 0%,
    rgba(52, 56, 59, 0.2) 50%,
    rgba(0, 0, 0, 0.1) 100%
  );
  /* opacity: 0.6; */
}

/deep/ .el-tabs__item {
  padding: 0 35px;
  color: #ffffff;
  font-size: 14px;
  font-family: "Regular";
  opacity: 1 !important;
}

.bannerClass {
  width: 100%;
  color: #ffffff;
  background-image: url("../../assets/service_bg1.png");
  background-position: center;
  background-size: cover;
  position: relative;
}
.tabs {
  position: fixed;
  bottom: 20px;
  text-align: center;
  margin: auto;
  width: 100%;
  z-index: 999;
}

.main_content {
  /* width: 1200px;
  margin: auto; */
  /* padding-top: 160px; */
  z-index: 99;
  text-align: left;
  .title {
    text-align-last: justify;
    font-size: 60px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    line-height: 1;
  }
  .title_line {
    height: 8px;
    margin-top: 20px;
  }
  .title2 {
    font-size: 24px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    margin-top: 20px;
  }
  .banner_btn {
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: rgba(0, 0, 0, 0);
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    cursor: pointer;
  }
}

.content2 {
  background-image: url("../../assets/service_bg2.png");
  background-position: center;
  background-size: cover;
}

.content3 {
  background-image: url("../../assets/service_bg3.png");
  background-position: center;
  background-size: cover;
}

.content4 {
  background-image: url("../../assets/service_bg4.png");
  background-position: center;
  background-size: cover;
}

.content5 {
  background-image: url("../../assets/service_bg5.png");
  background-position: center;
  background-size: cover;
}

.content6 {
  background-image: url("../../assets/service_bg6.png");
  background-position: center;
  background-size: cover;
}

.content7 {
  background-image: url("../../assets/service_bg7.png");
  background-position: center;
  background-size: cover;
}

.content8 {
  background-image: url("../../assets/service_bg8.png");
  background-position: center;
  background-size: cover;
}
.s_title1 {
  width: 780px;
}
.s_title2 {
  width: 780px;
}
.s_title3 {
  width: 780px;
}
.s_title4 {
  width: 780px;
}
.showhover {
  position: absolute;
  height: 400px;
  z-index: 1000;
  left: 10px;
  top: 20%;
  .hoveritem {
    background: #23262a;
    width: 200px;
    font-size: 12px;
    height: 80px;
    line-height: 80px;
    color: #fff;
    opacity: 0.7;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/service.vue